import React from 'react';
import { useIntl } from 'react-intl';
import { SideMenuProps } from './types';
import {
  StyledSideMenu,
  StyledSideMenuBadge,
  StyledSideMenuEyebrow,
  StyledSideMenuIconWrapper,
  StyledSideMenuLabel,
  StyledSideMenuLink,
  StyledSideMenuList,
  StyledSideMenuListItem,
  StyledSideMenuNav,
} from './styles';

const SideMenu: React.FC<SideMenuProps> = ({
  items,
  additionalItems,
  collapsed,
}) => {
  const intl = useIntl();
  return (
  <StyledSideMenu $collapsed={collapsed}>
    <StyledSideMenuNav $collapsed={collapsed}>
      {!collapsed && <StyledSideMenuEyebrow>{intl.formatMessage({ id: 'sidebar.workspace' })}</StyledSideMenuEyebrow>}
      <StyledSideMenuList hasMinHeight>
        {items.map(({ label, to, icon: Icon, key, isActive, badge }) => (
          <StyledSideMenuListItem {...{ key }}>
            <StyledSideMenuLink
              {...{ to, isActive }}
              $collapsed={collapsed}
              data-label={collapsed && typeof label === 'string' ? label : undefined}
              title={typeof label === 'string' ? label : undefined}
            >
              {Icon && (
                <StyledSideMenuIconWrapper $collapsed={collapsed}>
                  <Icon />
                </StyledSideMenuIconWrapper>
              )}
              {!collapsed && <StyledSideMenuLabel>{label}</StyledSideMenuLabel>}
              {badge != null && badge > 0 && (
                <StyledSideMenuBadge>{badge > 999 ? '999+' : badge}</StyledSideMenuBadge>
              )}
            </StyledSideMenuLink>
          </StyledSideMenuListItem>
        ))}
      </StyledSideMenuList>

      {additionalItems && (
        <>
          {!collapsed && <StyledSideMenuEyebrow style={{ paddingTop: '18px' }}>{intl.formatMessage({ id: 'sidebar.account' })}</StyledSideMenuEyebrow>}
          <StyledSideMenuList>
            {additionalItems.map(({ label, to, icon: Icon, key }) => (
              <StyledSideMenuListItem {...{ key }}>
                <StyledSideMenuLink
                  {...{ to }}
                  $collapsed={collapsed}
                  data-label={collapsed && typeof label === 'string' ? label : undefined}
                  title={typeof label === 'string' ? label : undefined}
                >
                  {Icon && (
                    <StyledSideMenuIconWrapper $collapsed={collapsed}>
                      <Icon />
                    </StyledSideMenuIconWrapper>
                  )}
                  {!collapsed && (
                    <StyledSideMenuLabel>{label}</StyledSideMenuLabel>
                  )}
                </StyledSideMenuLink>
              </StyledSideMenuListItem>
            ))}
          </StyledSideMenuList>
        </>
      )}
    </StyledSideMenuNav>
  </StyledSideMenu>
  );
};

export default SideMenu;
